import React from 'react';
import { Button } from '@/components/ui/button';

export const BlogFilterTabs: React.FC = () => {
    return (
        <div className="flex flex-wrap gap-2 mb-10 border-b border-border pb-4">
             <Button variant="secondary" size="sm" className="rounded-full px-6 bg-foreground text-background hover:bg-foreground/90">All Posts</Button>
             <Button variant="ghost" size="sm" className="rounded-full px-6">Compliance</Button>
             <Button variant="ghost" size="sm" className="rounded-full px-6">Best Practices</Button>
             <Button variant="ghost" size="sm" className="rounded-full px-6">Industry News</Button>
        </div>
    );
};
